import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import {
  FDBodyText, FDBox, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dashboardUri } from 'Consts/clientUris';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { ClickableTextRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ClickableTextRel';
import { useCancelChurn } from 'Hooks/useCancelChurn';
import LoadingIndicator from 'Components/UI/LoadingIndicator';

export default function RequestChurnWithConcessionsCompleteStepLayout() {
  const { resource } = useMetaLayoutContext();
  const { onCancelChurn, isCancelingChurn } = useCancelChurn(resource.relationship(fr.relationships.requestChurnCancel.name));

  // Refresh when you first get here, but only once. This refresh ensures that you can see the new "you have churned" state, if you have chosen to churn
  const { refreshPageContentCollection } = usePageContentContext();
  const [alreadyRefreshed, setAlreadyRefreshed] = useState(false);
  useEffect(() => {
    if (alreadyRefreshed) {
      return;
    }
    setAlreadyRefreshed(true);
    refreshPageContentCollection();
  }, [alreadyRefreshed, refreshPageContentCollection]);

  if (isCancelingChurn) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <LottieLoadingLayout>
          <FDStack direction={'column'} spacing={2}>
            {resource.withRelationship(
              fr.relationships.lottie.name,
              (rel) => (
                <FDBox padding={2}>
                  <LottieRel relationship={rel} />
                </FDBox>
              ),
              () => null,
            )}
            <MetaControlField attr="title" />
            <MetaControlField attr="description" />
          </FDStack>
        </LottieLoadingLayout>
      </DialogContent>
      <DialogActions>
        <FDStack direction="column" spacing={2} flex={1}>
          {resource.withRelationship(
            fr.relationships.requestChurnCancel.name,
            (rel) => (
              <>
                <FDPrimaryActionButton label="Return to dashboard" href={dashboardUri} flex={1} />
                <FDBodyText align="start" color="textSecondary" value={<ClickableTextRel relationship={rel} overrideOnClick={onCancelChurn} />} />
              </>
            ),
            () => <FDPrimaryActionButton label="Return to dashboard" href={dashboardUri} flex={1} />,
          )}
        </FDStack>
      </DialogActions>
    </>

  );
}
